module.exports = __webpack_public_path__ + "img/램페이저.a1433564.png";